// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"163":"bd5a00af","213":"9d521569","239":"d9d04dfb","291":"8563bd7d","295":"e7217731","446":"5afcc54e","614":"e635faa7","693":"da5c77cb","831":"ff998166","853":"520ea80a"}[chunkId] + ".chunk.js";
};